module.exports = __webpack_public_path__ + "static/GreggsBuilding-c341242110a816340c050cd868257cae.jpg";